// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"80e6443a","239":"f59430dc","455":"f20a35b9"}[chunkId] + ".chunk.js";
};